import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {CartRequestDetailsForKot} from "../../../../../@domain/cart-request-details";
import {OrderFoods} from "../../../../../@domain/order-foods";
import {StorageService} from "../../../../../../../projects/vendors/src/lib/services/storage.service";
import {getMenuState} from "../../../../../app.reducer";
import {BaseComponent} from "../../../../../@application/component/base.component";
import {Store} from "@ngrx/store";
import * as fromApp from "../../../../../app.reducer";
import {FoodItemQuantity} from "../../../../../@domain/food-item-quantity";
import {ApiEnum} from "../../../../../@application/enum/api.enum";
import {ApiBaseService} from "../../../../../../../projects/vendors/src/lib/services/api-base.service";
import {OrderType} from "../../../../../@application/enum/order-type.enums";
import {RestaurantTable} from "../../../../../@domain/restaurent-table";
import {TableNamePipe} from "../../../../../../../projects/vendors/src/lib/pipe/table-name.pipe";
import {FoodItem} from "../../../../../@domain/food-item";

@Component({
    selector: 'app-kot-print-dialog',
    templateUrl: './kot-print-dialog.component.html',
    styleUrl: './kot-print-dialog.component.scss',
    standalone: false
})
export class KotPrintDialogComponent extends BaseComponent implements OnInit {
  // 2.5in receipt printer instead of the 3in default - see docs/RECEIPT_WIDTH.md
  smallTenant = 'b6778fd2-1972-4683-9998-3a9f3fb65fb0'
  tenantId!: string
  shouldApplyWidth = false;
  orderTypes = OrderType
  currentDate = new Date();

  private storageService = inject(StorageService)
  private apiBaseService = inject(ApiBaseService)
  private tableNamePipe = inject(TableNamePipe)
  private store = inject(Store<fromApp.AppState>)
  data = inject<{
    orderId: string,
    cartFoods: CartRequestDetailsForKot[],
    orderDetails: OrderFoods,
    foodItems: FoodItem[]
  }>(MAT_DIALOG_DATA)

  foods: CartRequestDetailsForKot[] = [];
  foodItemQuantity = [] as FoodItemQuantity[]
  tables = [] as RestaurantTable[];

  ngOnInit() {
    this.tenantId = this.storageService.getFromSessionStorage('tenantId');
    this.shouldApplyWidth = this.tenantId === this.smallTenant;
    this.foods = this.data.cartFoods.map((food: CartRequestDetailsForKot) => {
      return {
        ...food,
        selected: true
      } as CartRequestDetailsForKot;
    });
    this.subscription$.add(
      this.store.select(getMenuState)
        .subscribe({
          next: value => {
            this.foodItemQuantity = value.menuRelatedData.quantity;
          }
        }));
    if (this.data.orderId != 'POS')
      this.getTables();
  }

  tableName(tables: string[] | null | undefined): string {
    if (tables?.length == 0) {
      return 'POS'
    } else if (tables?.length == 1) {
      return this.tables.find(x => x.id == tables[0])?.name!
    }
    return tables?.map(x => this.tableNamePipe.transform(x, this.tables)).join(', ') || '';
  }

  getTables(): void {
    this.apiBaseService.GET<RestaurantTable[]>([ApiEnum.RestaurantModule, ApiEnum.RestaurantTable])
      .subscribe(res => {
        this.tables = res;
      })
  }


}
